import { Link } from "react-router-dom";
import { FooterContainer } from "./style";
import { ReactComponent as FaceBookIcon } from "./../../assets/icons/facebook-logo.svg";
import { ReactComponent as TwitterIcon } from "./../../assets/icons/twitter-logo.svg";
import { ReactComponent as InstagramIcon } from "./../../assets/icons/instagram-logo.svg";
import { ReactComponent as LinkedInIcon } from "./../../assets/icons/linkedin-logo.svg";

const Footer = () => {
  return (
    <FooterContainer>
      <div className="footer-top">
        <div className="footer-left">
          <h2>Connect With Us</h2>
          <div className="footer-social-media__icons">
            <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer">
              <FaceBookIcon />
            </a>
            <a href="https://twitter.com/" target="_blank" rel="noopener noreferrer">
              <TwitterIcon />
            </a>
            <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
              <InstagramIcon />
            </a>
            <a href="https://www.linkedin.com/in/rahul-prem/" target="_blank" rel="noopener noreferrer">
              <LinkedInIcon />
            </a>
          </div>
        </div>
        
        <div className="footer-middle">
          <h2>Quick Links</h2>
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="book-shipment">Services</Link>
            </li>
            <li>
              <Link to="about">About</Link>
            </li>
            <li>
              <Link to="contact">Contact</Link>
            </li>
          </ul>
        </div>
        
        <div className="footer-right">
          <h2>Get in Touch</h2>
          <div className="contact-info">
            <div className="contact-item">
              <span>Email:</span>
              <a href="mailto:contact@blushawk.com">contact@blushawk.com</a>
            </div>
            <div className="contact-item">
              <span>Phone:</span>
              <a href="tel:+918300811267">+91 83008 11267</a>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div className="footer-bottom">
        <p>&copy;{new Date().getFullYear()} Blushawk. All Rights Reserved.</p>
        <p>Crafted with ❤️ by Blushawk Team</p>
      </div>
    </FooterContainer>
  );
};

export default Footer;